import React, { useEffect, useState, useCallback } from "react";
import { FileSignature, Eye } from "lucide-react";
import { Modal } from "./Modal";
import { Badge } from "./Badges";
import { fmtDate } from "../lib/format";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";
import { SubmissionView } from "../pages/Forms";

/** Per-customer "Signed Forms" listing — opened from the Customers DataTable. */
export function SignedFormsModal({ customer, canAcknowledge, onClose }) {
  const [rows, setRows] = useState(null);
  const [viewing, setViewing] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.get(`/customers/${customer.id}/form-submissions`);
      setRows(r.data);
    } catch (e) { toast.error(apiErr(e)); setRows([]); }
  }, [customer.id]);
  useEffect(() => { load(); }, [load]);

  return (
    <Modal open onClose={onClose} wide icon={FileSignature}
      title="Signed forms"
      subtitle={customer.customer_name}
      footer={<button className="btn gold" onClick={onClose}>Done</button>}>
      <div className="tbl-wrap">
        <table>
          <thead><tr><th>Form</th><th>Signed by</th><th>Date</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {rows === null && <tr><td colSpan={5} className="t-mut">Loading…</td></tr>}
            {rows && rows.length === 0 && <tr><td colSpan={5} className="t-mut">No forms have been signed by this customer yet.</td></tr>}
            {rows && rows.map((s) => (
              <tr key={s.id} data-testid={`cust-form-row-${s.id}`}>
                <td><span className="t-strong">{s.form_title}</span> <span className="s mono t-mut">{s.form_code} · rev {s.form_version}</span></td>
                <td>{s.signature_name}<div className="s mono t-mut">{s.submitted_by_email}</div></td>
                <td className="mono">{fmtDate(s.submitted_at)}</td>
                <td>{s.status === "acknowledged_by_pte" ? <Badge label="Acknowledged" cls="b-green" /> : <Badge label="New" cls="b-amber" />}</td>
                <td style={{ textAlign: "right" }}>
                  <button className="btn sm ghost" onClick={() => setViewing(s)} data-testid={`cust-form-view-${s.id}`}><Eye size={13} /> View</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {viewing && (
        <SubmissionView submissionId={viewing.id}
          canAcknowledge={canAcknowledge}
          onClose={() => setViewing(null)}
          onAcknowledged={() => { setViewing(null); load(); }}
        />
      )}
    </Modal>
  );
}
